import { useLang } from "@/lib/i18n";
import { SIGN_POS, CENTERS, LINES } from "@/components/horoscope/KundaliChart";

const SAMPLE = { 0: ["ascendant", "sun"], 1: ["rahu"], 3: ["moon"], 5: ["jupiter"], 6: ["venus"], 7: ["ketu"], 9: ["mars", "saturn"], 11: ["mercury"] };
const STARS = [[8, 18], [16, 70], [24, 40], [79, 22], [88, 64], [93, 30], [70, 85], [12, 88], [84, 88], [30, 12]];
const FONT = "Arial, Helvetica, 'Noto Sans Devanagari', Mukta, sans-serif";

export const KundaliArt = ({ testid }) => {
  const { planet } = useLang();
  return (
    <div className="relative h-72 sm:h-72 lg:h-80 overflow-hidden bg-[radial-gradient(ellipse_at_center,#3a0a14_0%,#0B1222_55%,#070B14_100%)]" data-testid={testid}>
      {STARS.map(([l, top], i) => (
        <span key={i} className="absolute w-1 h-1 rounded-full bg-[#FDE68A] starfield-twinkle-dot" style={{ left: `${l}%`, top: `${top}%`, animationDelay: `${i * 0.45}s` }} />
      ))}
      <div className="absolute inset-0 flex flex-col items-center justify-center py-3">
        <p className="font-deva text-[#E8C55A] text-sm mb-1 sparkle-text">॥ श्री गणेशाय नमः ॥</p>
        <svg viewBox="0 0 482 482" className="h-[86%] drop-shadow-[0_0_18px_rgba(212,175,55,0.35)]" role="img" aria-label="Kundali">
          <rect x="10" y="10" width="462" height="462" fill="#0B1222" fillOpacity="0.6" stroke="#D4AF37" strokeWidth="3" />
          <g stroke="#D4AF37" strokeOpacity="0.85" strokeWidth="2">
            {LINES.map(([x1, y1, x2, y2], i) => <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} />)}
          </g>
          {SIGN_POS.map(([x, y], i) => (
            <text key={i} x={x} y={y} fontSize="24" fill="#EF4444" fontWeight="700" fontFamily={FONT}>{i + 1}</text>
          ))}
          {Object.entries(SAMPLE).map(([h, keys]) => keys.map((k, r) => (
            <text key={k} x={CENTERS[h][0]} y={CENTERS[h][1] + (r - (keys.length - 1) / 2) * 34} textAnchor="middle" dominantBaseline="middle"
              fontSize="28" fontWeight="700" fontFamily={FONT} fill={k === "ascendant" ? "#F87171" : "#FDE68A"}>{planet(k)}</text>
          )))}
        </svg>
      </div>
    </div>
  );
};
